import { createSlice } from '@reduxjs/toolkit';

export interface CheckMethodModalSliceState {
  isOpen: boolean;
}

const initialState: CheckMethodModalSliceState = {
  isOpen: false,
};

const checkMethodModalSlice = createSlice({
  name: 'checkMethodModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { checkMethodModalSlice };
